export const generateIdentifier = ({
  airportCode = '',
  loungeId = '',
  pathname,
}) => {
  const page =
    pathname && pathname.includes('all-airports')
      ? 'all airports page'
      : loungeId
        ? 'lounge details page'
        : airportCode
          ? 'airport page'
          : 'home page';

  return page;
};

/**
 * This function generates custom event info
 * @param {{ type: string, target: { id: string }}} eventData - event data
 * @param {{ identifier: string, element: string, detail: string }} additionalInfo - additional info
 * @param {{ info: string, products: Array.<{type: string, description: string, locale: string}>}} metaInfo - meta info
 */

export const generateCustomEventInfo = (
  eventData,
  additionalInfo,
  metaInfo
) => {
  return {
    identifier: additionalInfo.identifier,
    type: eventData.type,
    element: additionalInfo.element || eventData.target.id,
    detail: additionalInfo.detail,
    timestamp: new Date().toISOString(),
    meta: {
      info: metaInfo.info || '',
      products: metaInfo.products || [],
    },
  };
};
